import React from 'react'

const ResponseSentImageQuestionary = () => {
  return (
    <svg
      width="69"
      height="56"
      viewBox="0 0 69 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2005 0.326023C36.5496 0.326023 44.0042 4.10551 48.9739 9.97365L44.7993 13.5542C40.8236 8.87959 34.8599 5.89579 28.2005 5.89579C16.0743 5.89579 6.33367 15.6429 6.33367 27.777C6.33367 39.9111 16.0743 49.6582 28.2005 49.6582C41.9169 49.6582 52.1545 37.2257 49.7691 23.8981L54.4406 19.8202C59.7085 37.2257 46.6878 55.1285 28.2005 55.1285C13.0925 55.1285 0.767578 42.7955 0.767578 27.6775C0.767578 12.5596 13.0925 0.226562 28.2005 0.226562V0.326023Z"
        fill="#BE9137"
      />
      <path
        d="M30.7548 28.2467L23.3002 18.798L23.2008 18.8974L17.8335 23.1742L29.7608 38.1927L48.944 21.732L68.1271 5.27138L63.6543 0L30.7548 28.2467Z"
        fill="black"
      />
    </svg>
  )
}

export default ResponseSentImageQuestionary
